import { render, staticRenderFns } from "./CreateContractDocumentAddTab.vue?vue&type=template&id=56ef4e56&scoped=true"
import script from "./CreateContractDocumentAddTab.vue?vue&type=script&lang=js"
export * from "./CreateContractDocumentAddTab.vue?vue&type=script&lang=js"
import style0 from "./CreateContractDocumentAddTab.vue?vue&type=style&index=0&id=56ef4e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef4e56",
  null
  
)

export default component.exports